import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import { Router } from '@angular/router';
import { AppConfigurationService } from './app-configuration.service';
import { loadAppConfiguration, loadAppConfigurationFailure, loadAppConfigurationSuccess, loadBrandingConfigurationFailure, loadBrandingConfigurationSuccess } from './app-configuration.actions';

@Injectable()
export class AppConfigurationEffects {
    constructor(
        private actions$: Actions,
        private appConfigurationService: AppConfigurationService,
        private router: Router
    ) { }

    loadAppConfiguration$ = createEffect(() =>
        this.actions$.pipe(
            ofType(loadAppConfiguration),
            switchMap(() =>
                this.appConfigurationService.loadAppConfiguration().pipe(
                    map((appConfiguration) => loadAppConfigurationSuccess({ configuration: appConfiguration })),
                    catchError((error) => of(loadAppConfigurationFailure({ error: error.message })))
                )
            )
        )
    );

    loadBrandingConfiguration$ = createEffect(() =>
        this.actions$.pipe(
            ofType(loadAppConfigurationSuccess),
            switchMap(() =>
                this.appConfigurationService.loadBrandingConfiguration().pipe(
                    map((brandingConfiguration) => loadBrandingConfigurationSuccess({ brandingConfiguration })),
                    catchError((error) => of(loadBrandingConfigurationFailure({ error: error.message })))
                )
            )
        )
    );
}